import React from 'react';
import { GeneralModal } from 'ui/GeneralModal';
import * as Inputs from '../Inputs';
import FluidButton from 'ui/FluidButton';
import { EMealPlanCategory, IAccommodationProduct, IHotel, IMealPlanProduct, ISeason } from 'services/BackendApi';
import { Room } from '../child-product-forms/Room';
import { produce } from 'immer';
import * as _ from 'lodash-es';
import { MealPlan } from '../child-product-forms/MealPlan';
import { validateMealPlan } from 'containers/HotelAdmin/validation';
import { enqueueNotification } from 'store/modules/ui';
import { useDispatch } from 'react-redux';
export const CreateMealPlanModal = ({
  onConfirm,
  onClose,
  hotel,
}: {
  onConfirm: (data: any) => void;
  onClose: () => void;
  hotel: IHotel;
}) => {
  const dispatch = useDispatch();
  const [draftMealPlan, setDraftMealPlan] = React.useState<Partial<IMealPlanProduct>>({
    category: 'perPersonPerNight',
    meta: {
      categoryType: EMealPlanCategory.RO,
      description: '',
    },
    options: {
      ages: [],
    },
  });

  return (
    <GeneralModal
      onClose={() => onClose()}
      modalWindowClassName="w-[1100px] px-[34px] py-25px rounded h-[80vh] overflow-y-scroll font-pt-sans"
      shouldCloseByClickingOutside={false}
    >
      <h1 className="font-normal font-noe-display text-[36px] leading-46px">Create new Meal Plan</h1>
      <MealPlan
        hotel={hotel}
        mode={'create'}
        mealPlan={draftMealPlan}
        onUpdate={(field, value) => {
          const newRoom = produce(draftMealPlan, _draftRoom => {
            _.set(_draftRoom, field, value);
          });
          setDraftMealPlan({
            ...newRoom,
          });
        }}
        onCta={() => {
          const validation = validateMealPlan(draftMealPlan);
          if (validation.isValid === false) {
            dispatch(
              enqueueNotification({
                message: `Meal plan is not valid: ${validation.message}`,
                options: { variant: 'warning' },
              })
            );
            return;
          }
          onConfirm(draftMealPlan);
        }}
        ctaLabel="Create Meal Plan"
      />
    </GeneralModal>
  );
};
